import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { QuoteWizardAnsweredForm } from '../components/QuoteWizard/classes';
import { getAllForms } from '../store/policystreamStore';
import { UnifiedCompletedForm } from '../Typescript/classes';
import {
  getAnsweredForms,
  policystreamStore,
} from '../store/policystreamStore';
import { hybridAnswers } from '../components/util/Quote';
import { QuoteWizardForm } from '../components/QuoteWizard/classes';
const {
  actions: { confirmAnswersForForms },
} = policystreamStore;

type SubmitPolicyStreamQuoteParams = Partial<
  Parameters<typeof confirmAnswersForForms>[0]
>;
export const useSubmitPolicyStreamQuote = (
  hookArgs: SubmitPolicyStreamQuoteParams = {},
) => {
  const forms = useSelector(getAllForms);
  const formAnswersInStore = useSelector(getAnsweredForms);
  const [amendedForms, setAmendedForms] = useState<Array<UnifiedCompletedForm>>(
    [],
  );
  const [relevantForms, setRelevantForms] = useState<Array<QuoteWizardForm>>(
    [],
  );
  const dispatch = useDispatch();

  // set the relevant forms - this is necessary because for policystream we don't want to fill in answers for forms with no answers at all (we sometimes load in forms before they're strictly required, which can lead to them being sent to the backend with all "N/A" answers)
  useEffect(() => {
    const newRelevantForms = forms.filter((form) => {
      formAnswersInStore.some((answeredForm) => {
        return answeredForm.form.apiName === form.apiName;
      });
    });
    setRelevantForms(newRelevantForms);
  }, [forms, formAnswersInStore]);

  // set the answers to actually be sent to the backend
  useEffect(() => {
    const amended = hybridAnswers(formAnswersInStore, relevantForms);
    setAmendedForms(amended);
  }, [forms, formAnswersInStore]);

  const submitQuote = useCallback(
    (localArgs: SubmitPolicyStreamQuoteParams = {}) => {
      const mergedArgs = {
        formsWithAnswers: amendedForms,
        ...hookArgs,
        ...localArgs,
      };
      dispatch(confirmAnswersForForms(mergedArgs));
    },
    [amendedForms],
  );

  return submitQuote;
};
